import { render, staticRenderFns } from "./cModalWsp.vue?vue&type=template&id=2c93efa4"
import script from "./cModalWsp.vue?vue&type=script&lang=js"
export * from "./cModalWsp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports